import type { ZodObject, ZodRawShape } from "zod";
import { ContentType } from "./ContentType.js";
import { brownCardBlockSchema } from "./content-blocks/brownCardBlockSchema.js";
import { ckEditorBlockSchema } from "./content-blocks/ckEditorBlockSchema.js";
import { galleryBlockSchema } from "./content-blocks/galleryBlockSchema.js";

export const contentBlockSchemaMap = {
	[ContentType.BrownCard]: brownCardBlockSchema,
	[ContentType.Gallery]: galleryBlockSchema,
	[ContentType.CKEditor]: ckEditorBlockSchema,
} satisfies Record<ContentType, ZodObject<ZodRawShape>>;
